/**
 * Social Element Colors — default color per mappable element type
 *
 * @module core/modules/social/constants/element-colors
 *
 * @description
 * Colores por defecto para los 6 tipos de elementos del módulo social
 * que se representan en el mapa. El usuario puede personalizar cada color
 * desde el panel.
 */

/** The 6 social element types that have map representation */
export type SocialElementId =
  | 'schools'
  | 'hospitals'
  | 'community'
  | 'sports'
  | 'cultural'
  | 'welfare';

export const SOCIAL_ELEMENT_COLORS: Record<SocialElementId, string> = {
  'schools':   '#3b82f6', // azul (escuelas)
  'hospitals': '#ef4444', // rojo (centros de salud)
  'community': '#10b981', // verde (centros comunitarios)
  'sports':    '#f59e0b', // ámbar (centros deportivos)
  'cultural':  '#8b5cf6', // violeta (espacios culturales)
  'welfare':   '#ec4899', // rosa (centros asistenciales)
};

/** Set of IDs for quick lookup */
export const MAPPABLE_ELEMENT_IDS = new Set<string>(
  Object.keys(SOCIAL_ELEMENT_COLORS),
);
